function formattedPrice(value, currency) {
    if(currency === undefined) {
        currency = '€'
    }

    return numberFormat(value) + ' ' + currency
}

function isNumber(value) {
    return ! Number.isNaN(parseInt(value))
}

function numberFormat(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? '.' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? ',' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    return s.join(dec);
}

function getNumber(str) {
    let number= str && str.length 
        ? str.replace(/\.|\D/g,'') 
        : 0

    return parseInt(number)
}

const leadingZeros = (number, totalLength) => {
    return String(number).padStart(totalLength, '0')
}

const roundDownMinutes = minutes => {
    let rounded = null

    if(minutes >= 45 ) {
        rounded = 45
    }
    else if(minutes >= 30 ) {
        rounded = 30
    }
    else if(minutes >= 15 ) {
        rounded = 15
    }
    else {
        rounded = 0
    }
    
    return leadingZeros(rounded, 2)
}

export {
    formattedPrice,
    isNumber,
    numberFormat,
    getNumber,
    leadingZeros,
    roundDownMinutes,
}
